import React, { useState } from 'react';

const PermissionTree = ({ catalog, permissions, pending, onToggle, readOnly }) => {
  const [expanded, setExpanded] = useState({});

  const getPerm = (componentId) => {
    if (pending[componentId]) return pending[componentId];
    return permissions[componentId] || { can_read: false, can_write: false };
  };

  return (
    <div className="space-y-2">
      {catalog.features.map((feature) => (
        <div key={feature.id} className="bg-card rounded-xl border border-border">
          <button
            type="button"
            onClick={() => setExpanded({ ...expanded, [feature.id]: !expanded[feature.id] })}
            className="w-full text-left px-4 py-3 flex items-center justify-between"
          >
            <span className="text-sm font-semibold text-foreground">{feature.label}</span>
            <span className="text-xs text-muted-foreground">
              {feature.sub_features.reduce((acc, sf) => acc + sf.components.length, 0)} components
            </span>
          </button>
          {expanded[feature.id] && (
            <div className="px-4 pb-3 space-y-3">
              {feature.sub_features.map((sf) => (
                <div key={sf.id}>
                  <div className="text-xs font-medium text-muted-foreground mt-2 mb-1">{sf.label}</div>
                  {sf.components.length === 0 && (
                    <div className="text-xs text-muted-foreground italic ml-2">(feature flag — no components)</div>
                  )}
                  {sf.components.map((c) => {
                    const p = getPerm(c.id);
                    const isPending = !!pending[c.id];
                    return (
                      <div
                        key={c.id}
                        className={`flex items-center justify-between py-1.5 ml-2 ${
                          isPending ? 'bg-yellow-50 -mx-2 px-2 rounded' : ''
                        }`}
                      >
                        <span className="text-sm text-foreground">{c.label}</span>
                        <div className="flex items-center gap-3">
                          <label className="flex items-center gap-1 text-sm text-muted-foreground">
                            <input
                              type="checkbox"
                              checked={p.can_read}
                              disabled={readOnly}
                              onChange={(e) => onToggle(c.id, 'can_read', e.target.checked)}
                            />
                            Read
                          </label>
                          <label className="flex items-center gap-1 text-sm text-muted-foreground">
                            <input
                              type="checkbox"
                              checked={p.can_write}
                              disabled={readOnly}
                              onChange={(e) => onToggle(c.id, 'can_write', e.target.checked)}
                            />
                            Write
                          </label>
                        </div>
                      </div>
                    );
                  })}
                </div>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default PermissionTree;
